if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select, fieldset input:checked')).map((element) => {
          if (element.tagName === 'SELECT') {
            const selectedOption = element.selectedOptions[0];
            return selectedOption.dataset.optionValueId || selectedOption.value;
          }

          return element.dataset.optionValueId || element.value;
        });
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);

          this.updateSelectedSwatchValue(event);

          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          const oldSelectedOption = Array.from(target.options).find((option) => option.getAttribute('selected'));

          if (oldSelectedOption) {
            oldSelectedOption.removeAttribute('selected');
          }

          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;

          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            ?.querySelector('[data-selected-value] > .swatch');

          if (!selectedDropdownSwatchValue) return;

          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target
            .closest('.product-form__input')
            ?.querySelector('[data-selected-value]');

          if (selectedSwatchValue) {
            selectedSwatchValue.textContent = value;
          }
        }
      }
    }
  );
}

/* Mobile: scroll to selected variant image after actual variant has changed */
if (window.FoxTheme && FoxTheme.pubsub) {
  FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, function (event) {
    const variant = event?.data?.variant;

    if (!variant || !variant.featured_media) return;
    if (window.innerWidth > 767) return;

    const mediaId = variant.featured_media.id;

    requestAnimationFrame(() => {
      const mediaButton = document.querySelector(`.product__media-zoom[data-media-id="${mediaId}"]`);

      if (!mediaButton) return;

      const mediaItem = mediaButton.closest('.product__media-item-container');

      if (!mediaItem) return;

      const img = mediaItem.querySelector('img');

      if (img) {
        img.loading = 'eager';
        img.fetchPriority = 'high';
      }

      const yOffset = -100;

      const y = mediaItem.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({
        top: y,
        behavior: 'auto',
      });
    });
  });
}

/* Re-initialize selected variant once when screen changes from desktop to mobile */
let mobileVariantMediaReady = false;

window.addEventListener(
  'resize',
  FoxTheme.utils.debounce(function () {
    if (window.innerWidth < 768 && !mobileVariantMediaReady) {
      mobileVariantMediaReady = true;

      setTimeout(() => {
        const selectedInput = document.querySelector('variant-selects input:checked, variant-selects select');

        if (selectedInput) {
          selectedInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }, 150);
    }

    if (window.innerWidth >= 768) {
      mobileVariantMediaReady = false;
    }
  }, 200)
);